import { Component } from "react";
import { withRouter } from "../../../../utils/withRouter";
import { connect } from "react-redux";
import Loader from "../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import HeaderWithLogo from "../../../../common_components/header_with_logo";
import AdminDrawer from "../../../../common_components/admin_module_drawer";
import { toastError, toastSuccess } from "../../../../utils/constants";
import { getWaterConnectionApprovalList_action, updateWaterConnectionApproval_action } from "../../../../actions/admin_module_action/manual_forms_admin_action/waterConnectionApproval_action/waterConnectionApproval_action";
import CommonModal from "../../../../utils/CommonModal";

class WaterConnectionApproval extends Component {
  //Initialized Constructor
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      CompanyName: "",
      eDirectoryApplicationList: [],
      isViewModalOpen: false,
      selectedComponent: null,
      selectedId: null,
    };
    this.getWaterConnectionApprovalList = this.getWaterConnectionApprovalList.bind(this);
    this.onCheckedAppliactions = this.onCheckedAppliactions.bind(this);
    this.onRemarkEnter = this.onRemarkEnter.bind(this);
    this.updateWaterConnectionApproval = this.updateWaterConnectionApproval.bind(this);
  }

  // On Component Load
  componentDidMount() {
    this.props.location.state != null &&
      this.props.location.state.companyName != "" &&
      this.getWaterConnectionApprovalList(this.props.location.state.companyName);

    this.setState({
      CompanyName:
        this.props.location.state != null && this.props.location.state.companyName
          ? this.props.location.state.companyName
          : "",
    });

    console.log(this.props);
  }

  // Get Exh Badges Appliactions
  getWaterConnectionApprovalList(companyname) {
    this.setState({ isLoading: true });
    this.props
      .getWaterConnectionApprovalList_action(companyname)
      .then((data) => {
        if (data.error != 1) {
          console.log("getWaterConnectionApprovalList Data", data.data);
          data.data.map((item) => {
            item.isSelected = false;
            item.isReadOnly = true;
          });
          this.setState({
            eDirectoryApplicationList: data.data,
            isLoading: false,
          });
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  // On Check Exh Badge Applications
  onCheckedAppliactions(e) {
    const { eDirectoryApplicationList } = this.state;
    var checked = e.target.checked;
    var id = e.target.value;

    eDirectoryApplicationList.length > 0 &&
      eDirectoryApplicationList.map((data) => {
        if (checked) {
          if (id == data.WaterFormID) {
            data.isSelected = true;
            data.isReadOnly = false;
          }
        } else {
          if (id == data.WaterFormID) {
            data.isSelected = false;
            data.isReadOnly = true;
          }
        }
      });
    console.log("09000909090", eDirectoryApplicationList);
    this.setState({});
  }

  /// On Remark Enter
  onRemarkEnter(e, id) {
    const { eDirectoryApplicationList } = this.state;
    var value = e.target.value;
    var list = [...eDirectoryApplicationList];
    list.length > 0 &&
      list.map((data) => {
        if (data.WaterFormID == id) {
          data.Remarks = value;
        }
      });
    console.log("0101010100101", list);
    this.setState({ eDirectoryApplicationList: list });
  }

  // On View E-Directory
  onViewClick(ServiceName, id) {
    this.setState({
      isViewModalOpen: true,
      selectedComponent: ServiceName,
      selectedId: id,
    });
  }

  // On Update Visa Approval
  updateWaterConnectionApproval(e, key) {
    const { eDirectoryApplicationList, CompanyName } = this.state;
    var applicationList = eDirectoryApplicationList.filter((item) => item.isSelected == true);
    var list;
    // checked Application List data Preparing to store
    var list = [];
    applicationList.map((data) => {
      var mapData = {
        WaterFormID: parseInt(data.WaterFormID),
        Remark: data.Remarks,
      };
      list.push(mapData);
    });
    const isCheckedRemark = list.every((item) => item.Remark != "" && item.Remark != null);
    if (list.length > 0) {
      if (key == 2 ? isCheckedRemark : true) {
        this.setState({ isLoading: true });
        this.props
          .updateWaterConnectionApproval_action(key == 1 ? true : false, list)
          .then((data) => {
            if (data.error != 1) {
              this.setState({ isLoading: false });
              toastSuccess(
                `Water Connection Form ${key == 1 ? "Approval" : "Disapproval"} Successfully!`
              );
              setTimeout(() => {
                this.getWaterConnectionApprovalList(CompanyName);
              }, 1000);
            } else {
              this.setState({ isLoading: false });
              toastError(data.msg);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        toastError("Please Enter Remark");
      }
    } else {
      toastError("Select Atleast One Application");
    }
  }

  onBackClick() {
    this.props.navigate("/waterConnectionAdmin");
  }

  render() {
    const { isLoading, eDirectoryApplicationList } = this.state;
    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        <HeaderWithLogo />
        <AdminDrawer />
        <div>
          <>
            <div className="with-dr-container">
              <div className="main-container">
                <div className="row m-0">
                  <div className="breadcrumb-scroll-fixed">
                    <h6 className="mb-0 p-2 text-white">Water Connection Approval</h6>
                  </div>
                </div>
              </div>

              <div className="admin-top-space pt-2">
                <div className="row mb-6 m-0">
                  {/* <div className="col-lg-12 mt-2">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <label htmlFor="validationCustom03">Login Name</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                defaultValue="jindal rectifiers"
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <label htmlFor="validationCustom03">Badge Quota</label>
                                            <input type="text" className="form-control" />
                                        </div>
                                        <div className="col-md-4">
                                            <label htmlFor="validationCustom03">Balance Quota</label>
                                            <input type="text" className="form-control" />
                                        </div>
                                    </div>
                                </div> */}
                  <div className="table-responsive">
                    <table className="table border text-nowrap text-md-nowrap table-bordered mb-0 ">
                      <thead>
                        <tr>
                          <th className="text-center">Sr.No</th>
                          <th className="text-center">Select</th>
                          <th className="text-center">Company Name</th>
                          <th>Name</th>
                          <th className="text-center">Country</th>
                          <th className="text-center">Status</th>
                          <th>Remarks</th>
                          <th>View</th>
                        </tr>
                      </thead>
                      <tbody>
                        {eDirectoryApplicationList.length > 0 &&
                          eDirectoryApplicationList.map((data, index) => (
                            <tr key={data.WaterFormID}>
                              <td className="text-center">{index + 1}</td>
                              <td className="text-center">
                                <input
                                  type="checkbox"
                                  checked={data.isSelected}
                                  value={data.WaterFormID}
                                  disabled={
                                    data.StatusID == "Approved" || data.StatusID == "Disapproved"
                                  }
                                  onChange={(e) => this.onCheckedAppliactions(e)}
                                />
                              </td>
                              <td className="text-center">{data.CompanyName}</td>

                              <td>{data.Name}</td>
                              <td className="text-center">{data.Country}</td>
                              <td className="text-center">{data.StatusID}</td>
                              <td>
                                <form>
                                  <input
                                    type="text"
                                    className="form-control"
                                    style={{ height: 40 }}
                                    disabled={data.isReadOnly}
                                    value={data.Remarks}
                                    onChange={(e) => this.onRemarkEnter(e, data.WaterFormID)}
                                  />
                                </form>
                              </td>
                              <td className="text-center">
                                <i
                                  class="fa fa-eye grid-icon"
                                  onClick={(e) => this.onViewClick("Water", data.WaterFormID)}
                                ></i>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="main-container mt-2">
                    <div className="mt-1 mb-4">
                      {eDirectoryApplicationList.some(data => data.StatusID == "Applied") &&
                        <>
                          <a
                            className="btn btn-aqua"
                            type="submit"
                            onClick={(e) => this.updateWaterConnectionApproval(e, 1)}
                          >
                            Approve
                          </a>
                          <a
                            className="btn btn-red m-1"
                            type="submit"
                            onClick={(e) => this.updateWaterConnectionApproval(e, 2)}
                          >
                            Reject
                          </a>
                        </>
                      }
                      <a
                        className="btn btn-gray m-1"
                        type="submit"
                        onClick={(e) => this.onBackClick()}
                      >
                        Back
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        </div>
        <CommonModal
          isOpen={this.state.isViewModalOpen}
          componentName={this.state.selectedComponent}
          componentProps={{
            is_View: true,
            FormID: this.state.selectedId,
          }}
          onClose={() => this.setState({ isViewModalOpen: false })}
        />
      </>
    );
  }
}
export default withRouter(connect(null, { getWaterConnectionApprovalList_action, updateWaterConnectionApproval_action })(WaterConnectionApproval))